import moment from "moment";
import { Field, useForm } from "react-final-form";
import { DatePicker } from "@pickit/pickit-components";
import { Input } from "component/inputs/Input";
import Select from "component/inputs/Select";
import { InvoiceTypes } from "sagas/types/preliquidation";
import { DATE_FORMATS, VALIDATION_REGEX } from "utils/constants";
import { InvoiceDataCLProps } from "./types";
import "../../i18n";
import { useTranslation } from "react-i18next";

const InvoiceDataCL = ({
  isFormEnabledCL,
  minDate,
  invoiceTypes,
  testId,
}: InvoiceDataCLProps) => {
  const { t } = useTranslation();
  const form = useForm();

  return (
    <>
      <Field
        type="text"
        name="emisionDate"
        disabled={!isFormEnabledCL}
        className="Admin-Pickers-input"
        placeholder={t("invoice:dateOfIssuePlaceholder")}
        label={t("invoice:dateOfIssueLabel")}
        language="es"
        outputFormat="DD/MM/YY"
        testId={`${testId}-field-emision-date`}
      >
        {(props: any) => (
          <div>
            <DatePicker
              singleSelection
              outputFormat={DATE_FORMATS.shortDate}
              minDate={minDate}
              maxDate={moment()}
              {...props}
            />
          </div>
        )}
      </Field>

      <div>
        <Field
          label={t("invoice:voucherTypeLabel")}
          disabled
          testId={`${testId}-field-voucher-type`}
          type="text"
          placeholder={t("invoice:voucherTypePlaceholder")}
          name="invoiceType"
          onChange={form.mutators.setValue}
          options={invoiceTypes.map((o: InvoiceTypes) => ({
            ...o,
            label: o.name,
          }))}
        >
          {(props: any) => <Select {...props} />}
        </Field>
      </div>
      <Field
        type="text"
        name="invoiceNumber"
        disabled={!isFormEnabledCL}
        label={t("invoice:invoiceNumberLabel")}
        component={Input}
        pattern={VALIDATION_REGEX.regNumber}
        className="Admin-Pickers-input"
        placeholder={t("invoice:enterNumber")}
        maxLength={16}
        testId={`${testId}-field-invoice-number`}
      />
    </>
  );
};

export default InvoiceDataCL;

